// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {};

export const $ctx = {
  // API_URL:
  //   process.env.NODE_ENV == 'production'
  //     ? 'https://wr1.com.vn/api/cont/cust/'
  //     : 'http://125.212.237.95:9020/cont/cust/',
  //   API_URL: 'http://localhost:9020/cont/cust/',
    // API_URL: 'http://125.212.237.95:9020/cont/cust/',
  //   API_URL: 'http://192.168.68.125:9020/cont/cust/',
  API_URL: 'https://wr1.com.vn/api/cont/cust/',
};

export const $dateFormat = { dateFormat: 'd/m/Y' };
// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {};

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: 'WR1', // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: require('@/assets/images/logo/logo.png'), // Will update logo in navigation menu (Branding)
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
  },
  lang: {
    enabled: true,
    meta: [
      { lang: 'en', text: 'English' },

      { lang: 'vn', text: 'Việt Nam' },
    ],
  },
};
